const getters = {
	userInfo: state => state.login.userInfo,
	token: state => state.login.token,
	roles: state => state.login.roles,
	projRoles: state => state.login.projRoles,
	curProjRoles: state => state.login.curProjRoles,
	curProjRoleId:state => state.login.curProjRoleId,
	isComplate: state => state.login.isComplate,
	newrouter: state => state.login.newrouter,
	permission_routers: state => state.permission.routers,
	operaPermList: state => state.permission.operaPermList,
	addRouters: state => state.permission.addRouters,
	subList: state => state.curRouter.subList,
	subChildrenList: state => state.curRouter.subChildrenList,
	curIndex:state => state.keepStatus.curIndex,
	syncFlag:state => state.keepStatus.flag,
	tagSet:state => state.tags.tagSet,
	cachedViews:state => state.tags.cachedViews,
	tagId:state => state.tags.tagId,
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js